import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 24 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 24.13: requires Betriebsstelle and Zugmeldestelle
 * - 24.14: requires Betriebsstelle and Zugmeldestelle
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl24EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2411 = findAuftrag(befehl, '24.11')
  if (auftrag2411) {
    const has2413_art = hasFieldContent(
      auftrag2411,
      '24.13',
      'zugmeldestelle.art'
    )
    const has2413_name = hasFieldContent(
      auftrag2411,
      '24.13',
      'zugmeldestelle.name'
    )
    const has2414_art = hasFieldContent(
      auftrag2411,
      '24.14',
      'zugmeldestelle.art'
    )
    const has2414_name = hasFieldContent(
      auftrag2411,
      '24.14',
      'zugmeldestelle.name'
    )

    // Return true if ANY field is empty
    return !has2413_art || !has2413_name || !has2414_art || !has2414_name
  }

  // Then check specific business rules
  const auftrag2412 = findAuftrag(befehl, '24.12')
  if (auftrag2412) {
    const has2413_art = hasFieldContent(
      auftrag2412,
      '24.13',
      'zugmeldestelle.art'
    )
    const has2413_name = hasFieldContent(
      auftrag2412,
      '24.13',
      'zugmeldestelle.name'
    )
    const has2414_art = hasFieldContent(
      auftrag2412,
      '24.14',
      'zugmeldestelle.art'
    )
    const has2414_name = hasFieldContent(
      auftrag2412,
      '24.14',
      'zugmeldestelle.name'
    )

    // Return true if ANY field is empty
    return !has2413_art || !has2413_name || !has2414_art || !has2414_name
  }
  return false
}
